import { fetchCustomerRequirement } from '../../services/crtService';
import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { pushNotificationMessage } from '../../views/components/Notification';
import { AppAction } from '../app';
import { call, put, takeLatest } from 'redux-saga/effects';
import { FETCH_CUSTOMER_REQUIREMENT } from './crt.actions';

function* fetchCustomerRequirementSaga(action: AppAction) {
  try {
    yield put({ type: REQUEST(action.type) });
    const { data } = yield call(fetchCustomerRequirement, action.payload);
    yield put({ type: SUCCESS(action.type), payload: { data } });
  } catch (error) {
    const errorMessage: string = error.response.data.message;
    yield put({ type: FAILURE(action.type), payload: { errorMessage } });
    yield put(pushNotificationMessage({ message: errorMessage, type: 'error' }));
  }
}

export default function* watchCustomerRequirement() {
  yield takeLatest(FETCH_CUSTOMER_REQUIREMENT, fetchCustomerRequirementSaga);
}
